module.exports = __webpack_public_path__ + "static/media/hg4.19b1c370.jpg";